export default "__VITE_ASSET__f6dde9a7__"